
<div class="em-block form-style">
  <div class="em-child">
    <h3>New Menu Folder</h3>

    <div>
      <label for="folder-name">Name</label>
      <input v-model="newFolder.name" type="text" id="folder-name">
    </div>

    <div class="cta">
      <button @click="cancel" type="button" class="btn red outline block">Cancel</button>
      <button @click="save" type="button" class="btn green block" :disabled="newFolder.name.length < 1">Save</button>
    </div>
  </div>
</div>
